import moment from "moment";
import * as Yup from "yup";
import { validaRg } from "../utils/validations";
import { ufs } from "./ufs";

const ERROR = {
  REQUIRED: "Campo Obrigatório",
  POSITIVE: "O valor tem que ser um número positivo",
  EMAIL: "Deve ser um e-mail válido",
  CNPJ: "CNPJ Inválido",
  CPF: "CPF Inválido",
  RG: "RG Inválido",
  TEL: "Telefone Inválido",
  CEL: "Celular Inválido",
  CEP: "CEP Inválido",
  UF: "UF Inválido",
  NIVER: "Data de Nascimento Inválido",
};

function is18Year(date) {
  const currentDate = moment();
  const dataInserted = moment(date, "DD/MM/YYYY", "pt-BR", true);
  const yearDiff = currentDate.diff(dataInserted, "years");
  return yearDiff >= 18;
}

function validDate(date) {
  return moment(date, "DD/MM/YYYY", true).isValid();
}

function validBirthDay(date) {
  return date && date.length === 10 && validDate(date) && is18Year(date);
}

// eslint-disable-next-line func-names
Yup.addMethod(Yup.string, "customBirthDay", function (message) {
  return this.test("customBirthDay", message, (value) => validBirthDay(value));
});

export const getSchemaTitular = (initialValues) =>
  Yup.object()
    .shape({
      nome: Yup.string()
        .required(ERROR.REQUIRED)
        .test("lastName", "Insira pelo menos um sobrenome", (name) => {
          if (!name) return false;
          const formattedName = name.trim().split(" ");
          return formattedName?.length > 1;
        })
        .matches(/^[\sa-zA-ZÀ-ÖØ-öø-ÿ]+$/, "O campo deve conter apenas letras"),

      nomeSocial: Yup.string()
        .min(3, "O nome social deve ter no mínimo 3 caracteres.")
        .max(80, "O nome social deve ter no máximo 80 caracteres.")
        .nullable(),

      email: Yup.string()
        .email(ERROR.EMAIL)
        .required(ERROR.REQUIRED)
        .nullable(),

      birthday: Yup.string()
        .min(10, "Data inválida")
        .customBirthDay("Data inválida")
        .required("Insira Uma Data Válida")
        .nullable(),

      rg: Yup.string()
        .nullable()
        .matches(/^[0-9]+$/, "O campo deve conter apenas números")
        .max(15, "Permitido até 15 caracteres.")
        .min(7, "Mínimo de 7 caracteres.")
        .test("rg", "O Rg é inválido", (value) => {
          if (!value) return true;
          const rgFormated = value.split(".").join("").replace("-", "");
          return validaRg(rgFormated);
        }),

      orgaoEmissor: Yup.string()
        .trim()
        .nullable()
        .matches(
          /^[a-zA-ZÀ-ÖØ-öø-ÿ ]+$/,
          "Orgão Emissor deve conter apenas letras"
        ),

      unidadeFederativaRG: Yup.string()
        .nullable()
        .test("unidadeFederativa", "UF Orgão Emissor inválida", (uf) => {
          if (uf === "Selecione a UF") return false;
          if (!uf) return true;
          return ufs.includes(uf.toUpperCase());
        }),

      dataEmissao: Yup.string().nullable().min(10, "Data inválida"),
    })
    .test(
      "check-rg-group",
      "Todos os campos do RG são obrigatórios se um deles for preenchido",
      function (formValues) {
        if (!initialValues) {
          return true;
        }

        const currentPattern = {
          rg: !!formValues.rg,
          orgaoEmissor: !!formValues.orgaoEmissor,
          dataEmissao: !!formValues.dataEmissao,
          unidadeFederativaRG: !!formValues.unidadeFederativaRG,
        };

        const initialPattern = {
          rg: !!initialValues.rg,
          orgaoEmissor: !!initialValues.orgaoEmissor,
          dataEmissao: !!initialValues.dataEmissao,
          unidadeFederativaRG: !!initialValues.unidadeFederativaRG,
        };

        const numFilledCurrent =
          Object.values(currentPattern).filter(Boolean).length;

        if (numFilledCurrent === 0 || numFilledCurrent === 4) {
          return true;
        }

        const isPatternUnchanged =
          currentPattern.rg === initialPattern.rg &&
          currentPattern.orgaoEmissor === initialPattern.orgaoEmissor &&
          currentPattern.dataEmissao === initialPattern.dataEmissao &&
          currentPattern.unidadeFederativaRG ===
            initialPattern.unidadeFederativaRG;

        if (isPatternUnchanged) {
          return true;
        }

        const errors = {};
        if (!formValues.rg) errors.rg = ERROR.REQUIRED;
        if (!formValues.orgaoEmissor) errors.orgaoEmissor = ERROR.REQUIRED;
        if (!formValues.dataEmissao) errors.dataEmissao = ERROR.REQUIRED;
        if (!formValues.unidadeFederativaRG)
          errors.unidadeFederativaRG = ERROR.REQUIRED;

        return new Yup.ValidationError(
          Object.entries(errors).map(([key, value]) => {
            return this.createError({ path: key, message: value });
          })
        );
      }
    );
